import { render, staticRenderFns } from "./AuthorizeClientInvoices.vue?vue&type=template&id=99cd40bc&scoped=true&"
import script from "./AuthorizeClientInvoices.vue?vue&type=script&lang=js&"
export * from "./AuthorizeClientInvoices.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizeClientInvoices.vue?vue&type=style&index=0&id=99cd40bc&scoped=true&lang=css&"
import style1 from "./AuthorizeClientInvoices.vue?vue&type=style&index=1&lang=css&"
import style2 from "../../../node_modules/handsontable/dist/handsontable.full.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cd40bc",
  null
  
)

export default component.exports